"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lightenColor = exports.lightenColor = function (color, percent) {
  if (!color || typeof color !== "string" || !color.startsWith("#")) {
    console.warn("Invalid color received:", color);
    return "#FFFFFF";
  }

  var hexToRgb = function hexToRgb(hex) {
    hex = hex.replace(/^#/, '');

    if (hex.length === 3) {
      hex = hex.split('').map(function (x) {
        return x + x;
      }).join('');
    }

    if (hex.length !== 6) return null;
    return {
      r: parseInt(hex.substring(0, 2), 16),
      g: parseInt(hex.substring(2, 4), 16),
      b: parseInt(hex.substring(4, 6), 16)
    };
  };

  var rgbToHex = function rgbToHex(r, g, b) {
    return "#".concat((1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1).toUpperCase());
  };

  var rgb = hexToRgb(color);

  if (!rgb) {
    console.warn("Failed to convert color to RGB:", color);
    return color;
  }

  var r = Math.round(rgb.r + (255 - rgb.r) * percent);
  var g = Math.round(rgb.g + (255 - rgb.g) * percent);
  var b = Math.round(rgb.b + (255 - rgb.b) * percent);
  var newColor = rgbToHex(r, g, b);
  return newColor;
};